export default function ImageIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_419_33368)">
        <path
          d="M9.00293 8.25C9.00293 8.84674 8.76588 9.41903 8.34392 9.84099C7.92196 10.2629 7.34967 10.5 6.75293 10.5C6.15619 10.5 5.5839 10.2629 5.16194 9.84099C4.73998 9.41903 4.50293 8.84674 4.50293 8.25C4.50293 7.65326 4.73998 7.08097 5.16194 6.65901C5.5839 6.23705 6.15619 6 6.75293 6C7.34967 6 7.92196 6.23705 8.34392 6.65901C8.76588 7.08097 9.00293 7.65326 9.00293 8.25Z"
          fill="#207E7D"
        />
        <path
          d="M3.00293 1.5C2.20728 1.5 1.44422 1.81607 0.881609 2.37868C0.319 2.94129 0.00292969 3.70435 0.00292969 4.5V19.5C0.00292969 20.2956 0.319 21.0587 0.881609 21.6213C1.44422 22.1839 2.20728 22.5 3.00293 22.5H21.0029C21.7986 22.5 22.5616 22.1839 23.1243 21.6213C23.6869 21.0587 24.0029 20.2956 24.0029 19.5V4.5C24.0029 3.70435 23.6869 2.94129 23.1243 2.37868C22.5616 1.81607 21.7986 1.5 21.0029 1.5H3.00293ZM21.0029 3C21.4008 3 21.7823 3.15804 22.0636 3.43934C22.3449 3.72064 22.5029 4.10218 22.5029 4.5V14.25L16.8374 11.3295C16.6968 11.259 16.5375 11.2346 16.3822 11.2596C16.2269 11.2847 16.0833 11.3579 15.9719 11.469L10.4069 17.034L6.41693 14.376C6.27287 14.2801 6.10007 14.237 5.92784 14.2539C5.7556 14.2709 5.59453 14.3468 5.47193 14.469L1.50293 18V4.5C1.50293 4.10218 1.66097 3.72064 1.94227 3.43934C2.22357 3.15804 2.6051 3 3.00293 3H21.0029Z"
          fill="#207E7D"
        />
      </g>
      <defs>
        <clipPath id="clip0_419_33368">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
